import { useState, useEffect } from 'react';
import { Input, Button, Checkbox } from 'antd';
import { EditOutlined, MenuOutlined } from '@ant-design/icons';

const AddMenu = ({ selectedItems, onSubmit, menuData, setSelectedItems }) => {
  const [menuId, setMenuId] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);

  const [autoAddPages, setAutoAddPages] = useState(false);

  const [displayLocation, setDisplayLocation] = useState({
    desktopHorizontal: true,
    desktopExpanded: false,
    mobile: true,
    footer: true,
    social: false,
  });

  useEffect(() => {
    if (menuData) {
      setMenuId(menuData._id || '');
      setTitle(menuData.title || '');
      setContent(menuData.content || '');

      setAutoAddPages(menuData.menuSettings?.autoAddPages || false);

      if (menuData.menuSettings?.displayLocation) {
        setDisplayLocation(menuData.menuSettings.displayLocation);
      }
    }
  }, [menuData]);

  const handleSubmit = () => {
    const payload = {
      menuId,
      content,
      title,
      items: selectedItems,
      menuSettings: {
        autoAddPages,
        displayLocation,
      },
    };

    onSubmit(payload);
  };

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '650px',
        paddingLeft: '20px',
      }}
    >
      <span
        style={{
          fontWeight: 700,
          fontSize: 24,
        }}
      >
        {menuData ? 'Edit Menu' : 'Add Menu'}
      </span>

      {/* MENU ID */}
      <div style={{ marginTop: 24 }}>
        <label style={{ fontWeight: 500 }}>Menu ID</label>
        <Input
          placeholder="1234"
          value={menuId}
          onChange={(e) => setMenuId(e.target.value)}
        />
      </div>

      {/* TITLE */}
      <div style={{ marginTop: 16 }}>
        <label style={{ fontWeight: 500 }}>Title</label>
        <Input
          placeholder="Enter title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      {/* EDITOR */}
      <div
        style={{
          marginTop: 32,
          fontSize: 13,
          color: '#777',
        }}
      >
        Add menu items from the column on the left.
      </div>

      {/* SELECTED MENU LIST */}
      <div style={{ marginTop: 20 }}>
        {selectedItems.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid #e5e5e5',
              borderRadius: 6,
              padding: '12px 16px',
              marginBottom: 10,
              background: '#fff',
            }}
          >
            {/* TOP ROW */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <MenuOutlined style={{ color: '#999' }} />
                <span>{item.name}</span>
              </div>

              <EditOutlined
                style={{ color: '#3b82f6', cursor: 'pointer' }}
                onClick={() =>
                  setEditingIndex(editingIndex === index ? null : index)
                }
              />
            </div>

            {editingIndex === index && (
              <div
                style={{
                  marginTop: 10,
                  display: 'flex',
                  gap: 8,
                  flexDirection: 'column',
                }}
              >
                <Input
                  placeholder="Enter menu name"
                  value={item.name}
                  onChange={(e) => {
                    const updated = [...selectedItems];
                    updated[index].name = e.target.value;
                    setSelectedItems(updated);
                  }}
                />

                <Input
                  placeholder="Enter custom URL"
                  value={item.url}
                  onChange={(e) => {
                    const updated = [...selectedItems];
                    updated[index].url = e.target.value;
                    setSelectedItems(updated);
                  }}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* SETTINGS */}
      <div style={{ marginTop: 30 }}>
        <div
          style={{
            fontWeight: 600,
            marginBottom: 10,
          }}
        >
          Menu Setting
        </div>

        <div style={{ marginBottom: 10 }}>
          <Checkbox
            checked={autoAddPages}
            onChange={(e) => setAutoAddPages(e.target.checked)}
          >
            Automatically add new top-level pages to the menu
          </Checkbox>
        </div>

        <div style={{ marginTop: 10 }}>
          <label style={{ display: 'block', marginBottom: 6 }}>
            Display location
          </label>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Checkbox
              checked={displayLocation.desktopHorizontal}
              onChange={(e) =>
                setDisplayLocation({
                  ...displayLocation,
                  desktopHorizontal: e.target.checked,
                })
              }
            >
              Desktop horizontal menu
            </Checkbox>

            <Checkbox
              checked={displayLocation.desktopExpanded}
              onChange={(e) =>
                setDisplayLocation({
                  ...displayLocation,
                  desktopExpanded: e.target.checked,
                })
              }
            >
              Desktop expanded menu
            </Checkbox>

            <Checkbox
              checked={displayLocation.mobile}
              onChange={(e) =>
                setDisplayLocation({
                  ...displayLocation,
                  mobile: e.target.checked,
                })
              }
            >
              Mobile menu
            </Checkbox>

            <Checkbox
              checked={displayLocation.footer}
              onChange={(e) =>
                setDisplayLocation({
                  ...displayLocation,
                  footer: e.target.checked,
                })
              }
            >
              Footer menu
            </Checkbox>

            <Checkbox
              checked={displayLocation.social}
              onChange={(e) =>
                setDisplayLocation({
                  ...displayLocation,
                  social: e.target.checked,
                })
              }
            >
              Social menu
            </Checkbox>
          </div>
        </div>
      </div>

      {/* ACTION BUTTON */}
      <div
        style={{
          marginTop: 30,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 10,
        }}
      >
        <Button>Preview</Button>
        <Button danger>Cancel</Button>
        <Button type="primary" onClick={handleSubmit}>
          {menuData ? 'Update Menu' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};

export default AddMenu;
